import { render, staticRenderFns } from "./workOrderBoard.vue?vue&type=template&id=8e39a8e2"
import script from "./workOrderBoard.vue?vue&type=script&lang=js"
export * from "./workOrderBoard.vue?vue&type=script&lang=js"
import style0 from "./workOrderBoard.vue?vue&type=style&index=0&id=8e39a8e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports